import { render } from "./permissionSettingRole.vue?vue&type=template&id=9eb09166&scoped=true"
import script from "./permissionSettingRole.vue?vue&type=script&lang=js"
export * from "./permissionSettingRole.vue?vue&type=script&lang=js"

import "./permissionSettingRole.vue?vue&type=style&index=0&id=9eb09166&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb09166"]])

export default __exports__